import { apiClient } from "./apiClient";

export const voiceApi = {
  transcribe: (audioBase64, format = "wav") =>
    apiClient.post("/voice/transcribe", { audio_base64: audioBase64, format }).then((r) => r.data),
  command: (payload) => apiClient.post("/voice/command", payload).then((r) => r.data),
  createAlias: (payload) => apiClient.post("/voice/alias", payload).then((r) => r.data),
  listAliases: () => apiClient.get("/voice/aliases").then((r) => r.data),
};
